import { useState } from 'react';
import { feedItems, feedTags } from '@/mocks/home';

export default function FeedSection() {
  const [activeTag, setActiveTag] = useState('all');
  const visibleItems = activeTag === 'all' ? feedItems : feedItems.filter((item) => item.tag === activeTag);

  return (
    <section id="feed" className="scroll-mt-24 border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <span className="text-xs font-medium uppercase tracking-[0.2em] text-primary-700">Daily Feed</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">今日看点与动态速览</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              入口变更、客户端更新与安全提醒会集中在这里发布。使用下方标签筛选你关心的类别。
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            {feedTags.map((tag) => (
              <button
                key={tag.id}
                type="button"
                onClick={() => setActiveTag(tag.id)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                  activeTag === tag.id
                    ? 'bg-primary-500 font-medium text-background-50'
                    : 'bg-background-100 text-foreground-700 hover:bg-background-200'
                }`}
              >
                {tag.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {visibleItems.map((item) => (
            <article key={item.id} className="flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <div className="relative aspect-[4/3] w-full overflow-hidden">
                <img src={item.img} alt={item.title} className="h-full w-full object-cover object-top" />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-0.5 text-xs font-medium text-foreground-800 backdrop-blur">
                  {item.tagLabel}
                </span>
                {item.hot && (
                  <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-0.5 text-xs font-medium text-background-50">
                    <i className="ri-fire-line text-xs" aria-hidden="true" />
                    热点
                  </span>
                )}
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-time-line" aria-hidden="true" />
                  {item.time}
                </div>
                <h3 className="mt-2 font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
              </div>
            </article>
          ))}
        </div>

        {visibleItems.length === 0 && (
          <p className="mt-8 rounded-lg border border-background-200 bg-background-100 px-4 py-6 text-center text-sm text-foreground-500">
            该类别暂无更新，切换其他标签查看。
          </p>
        )}
      </div>
    </section>
  );
}